/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import openToast from "./openToast";
import { sentryCaptureError } from "./errorFormatter";
import { getEnvs } from "state/EnvironmentsContext/EnvContext";

const warning = (error, info) => {
  const { isDevelopment, isStaging } = getEnvs((state) => state);
  if (isDevelopment || isStaging) {
    console.warn("######CAUGHT ERROR######");
    sentryCaptureError(error);

    if (error.hasOwnProperty("isCustom") && error.isCustom === true) {
      console.error(error?.error);
      console.groupCollapsed("Stack trace");
      console.error(Error(error?.stack));
      console.groupEnd();
    } else {
      if (isDevelopment && !window.location.href.includes("localhost")) {
        openToast(
          "Dear developer, please check the console for some fun.",
          "error",
        );
      }

      console.error(
        Error(error?.stack ?? error.message ?? JSON.stringify(error, null, 2)),
      );
    }

    if (info && info.componentStack) {
      console.groupCollapsed("React Component Stack");
      console.error(info.componentStack);
      console.groupEnd();
    }
  }
};

export default warning;
